
const initialState = {
  plan: null,
  orders: [],
  domains: [],
  activeOrder: null,
  loading: false
}

export default function zapmailReducer(state = initialState, { type, payload }) {
  switch (type) {
    case 'GET_ZAPMAIL_DOMAINS':
      return { ...state, loading: true };

    case 'SET_ZAPMAIL_PLAN':
      return { ...state, plan: payload };

    case 'SET_ZAPMAIL_ORDERS':
      return { ...state, orders: payload };

    case 'SET_ZAPMAIL_ACTIVE_ORDER':
      return { ...state, activeOrder: payload };

    case 'SET_ZAPMAIL_DOMAINS':
      return { ...state, domains: payload, loading: false };

    default:
      return state;
  }
}
